import axios from 'axios';

export const getConnectLink = (crm, redirectUrl = null) => {
  const connectLinks = {
    redtail: '/integrations/catalogue/auth/?crm=redtail',
  };

  const oAuthCrms = ['wealthbox', 'salesforce', 'practifi', 'salentica'];

  const redUrl = encodeURIComponent(
    redirectUrl ? redirectUrl : `${window.location.origin}/integrations/catalogue/auth/success/${crm}`
  );

  if (oAuthCrms.includes(crm)) {
    axios
      .get(`/api/?entity=vessel&action=getCrmAuthUrl&crm=${crm}&redirect_url=${redUrl}`)
      .then(data => window.location.replace(data.data.url));
  } else {
    window.location.replace(window.location.origin + '/' + (redirectUrl ? redirectUrl : connectLinks[crm]));
  }
};
